import "./App.css";

function App() {
  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-card">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: March 07, 2026</p>
        
        <p>
          MSK Developers built applications or games as Free applications. This Service is
          provided by MSK Developers at no cost and is intended for use as is. This
          page is used to inform visitors regarding my policies with the
          collection, use, and disclosure of Personal Information if anyone
          decided to use my Service.
        </p>
        
        <p>
          If you choose to use my Service, then you agree to the collection and
          use of information in relation to this policy. The Personal Information
          that I collect is used for providing and improving the Service. I will
          not use or share your information with anyone except as described in
          this Privacy Policy.
        </p>

        <h2>Information Collection and Use</h2>
        <p>
          For a better experience, while using our Service, I may require you to
          provide us with certain personally identifiable information. The
          information that I request will be retained on your device and is not
          collected by me in any way. We do not gather any personal data from our
          users.
        </p>
        
        <p>
          The app does use third-party services that may collect information used
          to identify you.
        </p>
        
        <div className="highlight-box">
          <p className="highlight-title">
            <strong>Link to the privacy policy of third-party service providers used by the app:</strong>
          </p>
          <ul className="provider-list">
            <li><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Play Services</a></li>
            <li><a href="https://support.google.com/admob/answer/6128543" target="_blank" rel="noopener noreferrer">AdMob</a></li>
            <li><a href="https://firebase.google.com/policies/analytics" target="_blank" rel="noopener noreferrer">Google Analytics for Firebase</a></li>
            <li><a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">Firebase Crashlytics</a></li>
            <li><a href="https://www.facebook.com/about/privacy" target="_blank" rel="noopener noreferrer">Facebook</a></li>
          </ul>
        </div>

        <h2>Log Data</h2>
        <p>
          I want to inform you that whenever you use my Service, in a case of an
          error in the app I collect data and information (through third-party
          products) on your phone called Log Data. This Log Data may include
          information such as your device Internet Protocol (“IP”) address, device
          name, operating system version, the configuration of the app when
          utilizing my Service, the time and date of your use of the Service, and
          other statistics.
        </p>

        <h2>Cookies</h2>
        <p>
          Cookies are files with a small amount of data that are commonly used as
          anonymous unique identifiers. These are sent to your browser from the
          websites that you visit and are stored on your device's internal memory.
        </p>

        <div className="google-required-section">
          <h2>Data Deletion Request</h2>
          <p>
            In compliance with Google Play Store requirements, if you wish to request deletion of your personal data collected through our app, please contact us at the email address provided below. We will process your request within a reasonable timeframe.
          </p>
        </div>

        <h2>Service Providers</h2>
        <p>
          I may employ third-party companies and individuals due to the following
          reasons:
        </p>
        <ul className="service-list">
          <li>To facilitate our Service</li>
          <li>To provide the Service on our behalf</li>
          <li>To perform Service-related services</li>
          <li>To assist us in analyzing how our Service is used.</li>
        </ul>
        
        <p>
          I want to inform users of this Service that these third parties have
          access to their Personal Information. The reason is to perform the tasks
          assigned to them on our behalf. However, they are obligated not to
          disclose or use the information for any other purpose.
        </p>

        <h2>Security</h2>
        <p>
          I value your trust in providing us your Personal Information, thus we
          are striving to use commercially acceptable means of protecting it. But
          remember that no method of transmission over the internet, or method of
          electronic storage is 100% secure and reliable, and I cannot guarantee
          its absolute security.
        </p>

        <div className="government-section">
          <h2>Government Information and Disclaimer Statement</h2>
          <p>
            Our app respects your privacy and aims to provide transparent
            information regarding the sources of data utilized. In compliance with
            regulations and to ensure clarity, we identify a clear source of
            government information within the app. This information serves to
            enhance transparency and credibility in the content provided.
          </p>
          
          <div className="disclaimer-box">
            <p>
              <strong>IMPORTANT DISCLAIMER:</strong> It's important to note that our app is not affiliated with any
              government entity. To avoid any misconceptions, we prominently display a
              disclaimer within the app, clarifying that it does not represent any
              government organization or agency. This disclaimer is easily visible and
              accessible to all users.
            </p>
          </div>
          
          <p>
            Additionally, we understand the significance of ensuring compliance
            across all platforms. Hence, we regularly monitor our app's store
            listing page to verify compliance with relevant regulations. If
            necessary, we include the same disclaimer on the store listing page to
            maintain consistency in messaging and transparency regarding our app's
            status as an independent entity. We remain committed to safeguarding
            your privacy and upholding transparency in our operations.
          </p>
          
          <p>
            We provide information to readers and visitors that is publicly
            available through various government public domains. The official website is loaded within the
            application in a WebView format for user convenience. However, this
            application is not an official government app, nor is it affiliated,
            sponsored, endorsed, or partnered with any government entity. We do not
            claim any official association with the Government of India or any
            related agencies.
          </p>
        </div>

        <h2>Links to Other Sites</h2>
        <p>
          This Service may contain links to other sites. If you click on a
          third-party link, you will be directed to that site. Note that these
          external sites are not operated by me. Therefore, I strongly advise you
          to review the Privacy Policy of these websites. I have no control over
          and assume no responsibility for the content, privacy policies, or
          practices of any third-party sites or services.
        </p>

        <h2>Children’s Privacy</h2>
        <p>
          These Services do not address anyone under the age of 13. I do not
          knowingly collect personally identifiable information from children
          under 13 years of age. In the case I discover that a child under 13 has
          provided me with personal information, I immediately delete this from
          our servers. If you are a parent or guardian and you are aware that your
          child has provided us with personal information, please contact me so
          that I will be able to do the necessary actions.
        </p>

        <h2>Changes to This Privacy Policy</h2>
        <p>
          We reserve the right to change the Terms and Privacy Policy from time to
          time as it sees fit and your continued use of the site will signify your
          acceptance of any adjustment to these terms. You are therefore advised
          to re-read the Terms and Privacy Policy on a regular basis. Should it be
          that you do not accept any of the modifications or amendments to the
          Terms and Privacy Policy, you may terminate your use of this application
          immediately.
        </p>

        <div className="contact-section">
          <h2>Contact Us</h2>
          <p>
            If you have any questions or suggestions about my Privacy Policy, or if you wish to request data deletion, please do not hesitate to contact me.
          </p>
          <div className="contact-info">
            <div className="contact-item">
              <span className="contact-label">Email:</span>
              <a href="mailto:kushwahmansingh397@gmail.com" className="contact-link">
                kushwahmansingh397@gmail.com
              </a>
            </div>
            <div className="contact-item">
              <span className="contact-label">Contact No:</span>
              <span className="contact-text">+91 - 6232-066788</span>
            </div>
          </div>
        </div>
        
        <div className="footer-note">
          <p>© 2026 MSK Developers. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}

export default App;